import { Styles } from '@typings/common';

export const rowDisabled: Styles = {
  '& td, th': {
    color: 'action.disabled',
  },
};
